export const ARTICLE_CATEGORIES_QUERY = '/api/articles/categories';

export const ARTICLES_QUERY = '/api/articles?search=';
export const ARTICLES_QUERY_HITS = 12;

export const FEATURED_ARTICLES_QUERY = '/api/articles?featured=true';

export const ARTICLE_QUERY = '/api/articles';

export const SUGGESTION_QUERY_CONTENT = '/api/completion/content';
export const SUGGESTION_QUERY_COMBINED = '/api/completion/combined';
